import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { LocalizationService } from './localization.service';

export const Ng1LocalizationModule = angular
  .module('control-room.shared.services.localization', [])
  .factory('crLocalizationService', downgradeInjectable(LocalizationService));